import request from '@/utils/http';

// 地址解析 - 根据详细地址返回省市区镇、经纬度信息
export const addressGeocoding = address => {
    return request({
        url: `/anapi-oms/searchagg/gis/searchByAddress`,
        method: 'post',
        data: address
    });
};

// 地址解析 - 根据详细地址返回省市区镇、经纬度信息
export const getGisInfoFromDetailAddress = address => {
    return request({
        url: `/api-ntp/ntp/wechat/getGisInfoFromDetailAddress?address=${address}`,
        method: 'get',
        options: {
            silent: true
        }
    });
};

// 地址解析 - 根据经纬度解析地址信息
export const getDetailAddressByGis = (lng, lat) => {
    return request({
        url: `/api-ntp/ntp/wechat/geDetailAddressByGis?lng=${lng}&lat=${lat}`,
        method: 'get'
    });
};

// 获取两个地址间的公里数
export const calcDistanceByTwoPoints = data => {
    return request({
        url: '/api-ntp/ntp/wechat/calcDistanceByTwoPoints',
        method: 'post',
        data: data
    });
};
